import { ReactNode } from "react";
import { Tabs } from "@mantine/core";
import { CustomTable } from "../../../../components/Table/CustomTable";
import { TransactionTypes } from "../../../DataDisplayTable/TransactionTable";
import TransactionTab from "./TransactionTab";
import { ThProps } from "../../../../components/TransactionPage/TransactionPage";
import { RowDataTransaction } from "../../../../components/TransactionPage/types";

export enum ColumnHeaderToFilterPairCoins {
    TRANSACTION_ID = "Transaction ID",
    FULLNAME = "Name",
    TYPE = "Type",
    COINS = "Coins",

    CREATED = "Created At",
    REMARK = "Remark",
}

export const colFilterCoins = ColumnHeaderToFilterPairCoins;
export const colFiltersCoins: { [key in ColumnHeaderToFilterPairCoins]: string } = {
    [colFilterCoins.TRANSACTION_ID]: "transaction_id",
    [colFilterCoins.FULLNAME]: "fullname",
    [colFilterCoins.TYPE]: "type",
    [colFilterCoins.COINS]: "coins",

    [colFilterCoins.CREATED]: "createdAt",
    [colFilterCoins.REMARK]: "remarks",
};

class CoinsTab extends TransactionTab {

    constructor(sortBy: keyof RowDataTransaction | null, setSorting: { (field: keyof RowDataTransaction): void }, Th: { ({ children, sortable, reversed, sorted, onSort }: ThProps): JSX.Element }, rowDataTransaction: RowDataTransaction[] | null) {
        super(sortBy, setSorting, Th, rowDataTransaction)
    }

    create(reverseSortDirection: boolean, classes: { readonly [key: string]: string }, rows: JSX.Element[]): ReactNode {
        return (
            <Tabs.Panel value={TransactionTypes.COINS}>
                <CustomTable
                    colHeaders={Object.values(ColumnHeaderToFilterPairCoins)}
                    filters={Object.values(colFilterCoins)}
                    reverseSortDirection={reverseSortDirection}
                    sortBy={this.sortBy}
                    setSorting={this.setSorting}
                    customclasses={classes}
                    Th={this.Th}
                    rowData={this.rowDataTransaction}
                    rows={rows}
                />
            </Tabs.Panel>
        )
    }

}

export default CoinsTab